<div class="linked-outcomes-panel">
    <div class="results-header" [ngClass]="getGoalClass(goal.name)">
        <div>Outcome ID</div>
        <div>Hub Record Name</div>
        <div class="responsive-hide">Hub Record Type</div>
        <div class="responsive-hide">2030 Goal Metric</div>
        <div>Total Progress</div>
    </div>

    @for (linkedOutcome of linkedOutcomes; track linkedOutcome.id) {
    <div class="result-row">
        <div>{{linkedOutcome.projectOutcome.outcome.uniqueId}}</div>
        <div>
            <a href="/portfolio/{{linkedOutcome.projectOutcome.projectId}}" target="_blank">{{linkedOutcome.project.name}}</a>
        </div>
        <div class="responsive-hide">{{linkedOutcome.project.projectType.name}}</div>
        <div class="responsive-hide">{{linkedOutcome.projectOutcome.outcome.outcomeMetric.name}}</div>
        <div>{{displayProgress(linkedOutcome) | number: '1.0-0' }} {{displayPreferredOutcomeMetricName()}}</div>
    </div>
    }
</div>
